import { Injectable } from '@angular/core';
import { TiposCreditos, CreditosKeys } from './helpers.service';

@Injectable()
export class ReportsHelperService {

    public getInfoTipoCredito(tipoCredito: string){
        let credito = { label: null, id: null };

        switch(tipoCredito){
            case CreditosKeys.Hipotecario:
                credito.label = 'HIPOTECARIO';
                credito.id = TiposCreditos.Hipotecario;
                break;
            case CreditosKeys.Automotriz:
                credito.label = 'AUTOMOTRIZ';
                credito.id = TiposCreditos.Automotriz;
                break;
            case CreditosKeys.Prendario:
                credito.label = 'PRENDARIO';
                credito.id = TiposCreditos.Prendario;
                break;
            case CreditosKeys.Verde:
                credito.label = 'VERDE';
                credito.id = TiposCreditos.Verde;
                break;
            case CreditosKeys.Personal:
                credito.label = 'PERSONAL';
                credito.id = TiposCreditos.Personal;
                break;
            case CreditosKeys.Nomina:
                credito.label = 'NOMINA';
                credito.id = TiposCreditos.Nomina;
                break;
            case CreditosKeys.Carburacion:
                credito.label = 'CREDIGAS CARBURACION';
                credito.id = TiposCreditos.Carburacion;
                break;
            case CreditosKeys.Estacionario:
                credito.label = 'CREDIGAS ESTACIONARIO';
                credito.id = TiposCreditos.Estacionario;
                break;
        }

        return credito;
    }

    public getDefaultDates() {
        let now = new Date();
        let defaultFechaFin =  now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
        
        let endDate = new Date();
        //La fecha fin debe ser un mes antes a hoy menos un día (solicitud de profinmex)
        endDate.setMonth(endDate.getMonth() - 1);
        endDate.setDate(endDate.getDate() + 1);
        let defaultFechaInicio =  endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate();
    
        let defaultDates = {
            fechaInicio: defaultFechaInicio,
            fechaFin: defaultFechaFin
        }

        return defaultDates;
    }

    public getDefaultCobranzaDate() {
        var nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        nextMonth.setDate(nextMonth.getDate() - 1);
        
        let defaultDate =  nextMonth.getFullYear() + "-" + (nextMonth.getMonth() + 1) + "-" + nextMonth.getDate();

        return defaultDate;
    }

    public isNumber(s) {
        if(s === null || s === undefined){
            return false;
        }
        var x = +s; // made cast
        return x.toString() === s;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/tools/reports-helpers.service.ts